import { Headset } from 'lucide-react';
import { OPTIBOT_GRADIENT } from '../utils/constants';

/**
 * Support agent avatar — same green gradient circle as BotAvatar but with a headset icon.
 * Used next to messages injected from a live HubSpot support agent.
 */
export function AgentAvatar() {
  return (
    <div
      className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full"
      style={{ background: OPTIBOT_GRADIENT }}
    >
      <Headset className="h-4 w-4 text-white" />
    </div>
  );
}
